module.exports = __webpack_public_path__ + "img/example_group_chat.e4e7ff30.jpg";